import { React, RouteComponentProps, debug, george, observer, pr, ui, theme, observable } from "aaa";
import { history } from "stores/RouterStore";

export const WebView = (props: RouteComponentProps<{
    webUrl?: string
}> & {
    blob?: Blob,
    url?: string,
    onClose?: () => void
}
) => {
    let url;
    if (props.match.params.webUrl) {
        url = decodeURIComponent(props.match.params.webUrl);
    } else if (props.url) {
        url = props.url;
    } else if (props.blob) {
        url = URL.createObjectURL(props.blob);
    }

    if (!url) {
        return null;
    }

    return (
        <div style={{ position: "relative", width: "100%", height: "100%" }}>
            <pr.IconCancelCircle
                style={{
                    position: "fixed",
                    top: 10,
                    right: 10,
                    zIndex: 10,
                    width: 40,
                    height: 40,
                    color: "white",
                    background: theme.customColors.georgeBlue,
                    borderRadius: 20
                }}
                onClick={() => props.onClose ? props.onClose() : history.goBack()}
            />

            <iframe
                src={url}
                frameBorder={0}
                style={{
                    width: Math.min(theme.MAX_APP_WIDTH, ui.windowWidth),
                    height: ui.windowHeight,
                    overflow: "auto",
                    // webkitOverflowScrolling: "touch",
                    // align: "middle",
                    // scrolling: "yes",
                }}
            />
        </div>
    );

};



// WEBPACK FOOTER //
// ./src/components/common/WebView.tsx